/**
 * TTD (Text-to-Diagram) trigger for opening the AI dialog.
 * The menu item is rendered directly in the toolbar (Actions.tsx) and
 * mobile toolbar (MobileToolBar.tsx) so it stays inside DropdownMenu context.
 * This component is a no-op to avoid "MenuItem must be used within Menu"
 * when rendered outside a Menu (e.g. via tunnel or custom layout).
 */
import type { JSX, ReactNode } from "react";

export const TTDDialogTrigger = ({
  children,
  icon,
}: {
  children?: ReactNode;
  icon?: JSX.Element;
}) => {
  return null;
};
TTDDialogTrigger.displayName = "TTDDialogTrigger";
